import React from 'react';

const AddressBook = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='18'
            height='26'
            viewBox='0 0 18 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M16 0C17.1046 0 18 0.895431 18 2V24C18 25.1046 17.1046 26 16 26H2C0.895431 26 4.02666e-08 25.1046 0 24V2C0 0.895431 0.895431 8.05319e-09 2 0H16ZM5.2959 13.333C5.01601 13.333 4.76384 13.5011 4.66699 13.7637C4.42378 14.4238 4 15.7106 4 16.667C4.0001 17.6233 4.4238 18.9092 4.66699 19.5693C4.76378 19.832 5.01593 20 5.2959 20H12.7041C12.9841 20 13.2362 19.832 13.333 19.5693C13.5762 18.9092 13.9999 17.6233 14 16.667C14 15.7106 13.5762 14.4238 13.333 13.7637C13.2362 13.5011 12.984 13.333 12.7041 13.333H5.2959ZM9 5C7.15916 5 5.66717 6.49221 5.66699 8.33301C5.66699 10.174 7.15905 11.667 9 11.667C10.8409 11.667 12.333 10.1739 12.333 8.33301C12.3328 6.49222 10.8408 5.00001 9 5Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default AddressBook;
